import React, { useEffect, createElement } from 'react';
import { Shield, Check, ArrowRight, Wrench, AlertTriangle, DollarSign } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQ } from './components/FAQ';
const CHECKOUT_URL = 'https://checkout.larutadelconocimiento.com/cart/43864240849005:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/oJ5VGrXebRBKexBHZdwsuu/Diseno_sin_titulo_(2).png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/v4UXfJDACzmaybWMLMKTYv/ChatGPT_Image_6_feb_2026,_11_12_18_a.m..png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/5zBtvDG1PAtNAz53ud8eyS/ChatGPT_Image_6_feb_2026,_11_12_24_a.m..png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/nDUXqJSxuLtGMa6TGX1wBi/ChatGPT_Image_6_feb_2026,_11_21_02_a.m..png';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '1375239330854800');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  const scrollToCheckout = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-gray-50 min-h-screen pb-8" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* 1. URGENCY HEADER BAR */}
      <div className="bg-red-600 text-white py-1 px-2 sticky top-0 z-40 shadow-md" data-id="element-2">
        <div className="max-w-6xl mx-auto flex items-center justify-center text-center" data-id="element-3">
          <div className="flex items-center space-x-2" data-id="element-4">
            <span className="font-bold uppercase text-xs md:text-sm tracking-wider" data-id="element-5">
              ⏳ OFERTA EXPIRA EN:
            </span>
            <CountdownTimer data-id="element-6" />
          </div>
        </div>
      </div>

      {/* 2. HERO SECTION */}
      <header className="bg-white pt-8 pb-10 px-4 border-b-8 border-yellow-500" data-id="element-7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-8">
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-9">
            MEGAPACK TÉCNICO RENTABLE
          </h1>

          <p className="text-yellow-600 font-bold tracking-wide uppercase mb-6 text-xs md:text-sm" data-id="element-10">
            🔧 Para técnicos, reparadores, emprendedores y personas en Argentina
            que quieren generar ingresos reales reparando herramientas
            eléctricas
          </p>

          <div className="mb-6 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-11">
            <img src={MAIN_IMAGE} alt="MegaPack Técnico Rentable Completo" className="mx-auto w-full max-w-lg drop-shadow-2xl cursor-pointer" onClick={scrollToCheckout} data-id="element-12" />
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-13">
            El sistema profesional para reparar herramientas eléctricas{' '}
            <span className="bg-yellow-200 px-1" data-id="element-14">sin improvisar</span> y
            convertir cada reparación en ingresos reales
          </h2>

          <button onClick={scrollToCheckout} className="inline-flex items-center justify-center w-full md:w-auto px-8 py-5 text-xl md:text-2xl font-bold text-white bg-green-600 rounded-lg shadow-xl hover:bg-green-700 hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-15">
            <span className="w-full text-center" data-id="element-16">
              👉 SÍ, QUIERO ACCEDER AHORA
            </span>
          </button>

          <div className="mt-4 flex items-center justify-center text-sm text-gray-500 font-semibold" data-id="element-17">
            <Shield className="w-4 h-4 mr-1 text-green-600" data-id="element-18" />✅ Garantía de
            satisfacción de 7 días
          </div>
        </div>
      </header>

      {/* 3. PAIN POINTS */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-19">
        <div className="max-w-3xl mx-auto" data-id="element-20">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-21">
            Si reparás herramientas, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white p-8 rounded-xl shadow-md border-l-8 border-red-500" data-id="element-22">
            <p className="text-xl font-bold mb-6 text-gray-800" data-id="element-23">
              ¿Te pasa que diagnosticar una herramienta te hace perder más
              tiempo que arreglarla?
            </p>

            <p className="mb-6 text-gray-700" data-id="element-24">
              No porque no sepas. No porque seas nuevo. Sino porque cuando una
              herramienta falla en serio, aparecen problemas reales:
            </p>

            <ul className="space-y-4" data-id="element-25">
              {['No estás seguro dónde está la falla', 'Probás piezas "a ver si es eso"', 'Perdés tiempo y plata en diagnósticos errados', 'Reparás… pero después dudás cuánto cobrar', 'Terminás laburando mucho para ganar poco'].map((item, i) => <li key={i} className="flex items-start" data-id="element-26">
                  <div className="bg-red-100 p-1.5 rounded-full mr-3 mt-0.5 flex-shrink-0" data-id="element-27">
                    <XIcon className="w-4 h-4 text-red-600" data-id="element-28" />
                  </div>
                  <span className="text-gray-800 font-medium" data-id="element-29">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-gray-800 font-bold italic border-t pt-4 text-lg" data-id="element-30">
              Y cuando entra otra herramienta al taller… ya arrancás cansado y
              con dudas.
            </p>
          </div>

          {/* EXTRA STRATEGIC BUTTON */}
          <div className="mt-10 text-center" data-id="element-31">
            <button onClick={scrollToCheckout} className="inline-flex items-center justify-center px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 transition-all transform hover:-translate-y-1 border-b-4 border-green-800" data-id="element-32">
              🔧 QUIERO DEJAR DE IMPROVISAR
            </button>
          </div>
        </div>
      </section>

      {/* 4. PROBLEM SECTION - Black Background */}
      <section className="py-12 px-4 bg-gray-900 text-white" data-id="element-33">
        <div className="max-w-3xl mx-auto text-center" data-id="element-34">
          <h2 className="text-3xl font-bold mb-6 text-red-500 uppercase tracking-wide" data-id="element-35">
            El problema que nadie dice en voz alta
          </h2>
          <p className="text-xl mb-8 leading-relaxed text-gray-300" data-id="element-36">
            Si querés reparar herramientas eléctricas y hacer plata con eso,
            suele pasar esto:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mb-8" data-id="element-37">
            {['Tenés conocimientos, pero no un método claro', 'Acumulás herramientas "para cuando tenga tiempo"', 'Diagnosticás más por intuición que por proceso', 'Cobrás sin una estructura definida', 'Improvisás más de lo que te gustaría'].map((item, i) => <div key={i} className="flex items-center bg-gray-800 p-4 rounded-lg border border-gray-700 shadow-sm" data-id="element-38">
                <div className="w-3 h-3 bg-red-500 rounded-full mr-3 flex-shrink-0" data-id="element-39"></div>
                <span className="font-medium" data-id="element-40">{item}</span>
              </div>)}
          </div>

          <p className="mt-8 text-2xl font-light italic text-gray-300" data-id="element-41">
            Y queda esa sensación constante de: <br data-id="element-42" />
            <span className="text-white font-bold bg-red-900/50 px-2 py-1 rounded mt-2 inline-block" data-id="element-43">
              "Con esto podría ganar mejor… si tuviera un sistema de verdad."
            </span>
          </p>
        </div>
      </section>

      {/* 5. SOLUTION INTRO */}
      <section className="py-14 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-44">
        <div className="max-w-4xl mx-auto text-center" data-id="element-45">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-1.5 rounded-full mb-6 text-sm tracking-widest uppercase" data-id="element-46">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-47">
            🔧 MEGAPACK TÉCNICO RENTABLE
          </h2>
          <p className="text-xl text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-48">
            Un sistema completo, estructurado y profesional para:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-49">
            {['Diagnosticar sin adivinar', 'Reparar con criterio técnico', 'Cobrar lo que corresponde', 'Convertir cada reparación en ingreso real'].map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow border-b-4 border-yellow-500 flex items-center justify-center text-center h-full" data-id="element-50">
                <span className="font-bold text-gray-800" data-id="element-51">{item}</span>
              </div>)}
          </div>

          <div className="bg-yellow-100 p-6 rounded-2xl border-2 border-yellow-400 mb-8 inline-block" data-id="element-52">
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-lg font-bold text-gray-900" data-id="element-53">
              <span className="flex items-center" data-id="element-54">
                <span className="text-2xl mr-2" data-id="element-55">📂</span> Abrís el material
              </span>
              <span className="hidden md:block text-yellow-500" data-id="element-56">➜</span>
              <span className="flex items-center" data-id="element-57">
                <span className="text-2xl mr-2" data-id="element-58">👆</span> Seguís el método
              </span>
              <span className="hidden md:block text-yellow-500" data-id="element-59">➜</span>
              <span className="flex items-center" data-id="element-60">
                <span className="text-2xl mr-2" data-id="element-61">🔧</span> Reparás y cobrás con
                seguridad
              </span>
            </div>
          </div>

          <p className="text-2xl font-bold text-gray-900 mb-8" data-id="element-62">
            Sin vueltas. Sin chamuyo. Sin regalar tu laburo.
          </p>

          <button onClick={scrollToCheckout} className="inline-block px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-full shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-63">
            👉 QUIERO MI SISTEMA TÉCNICO RENTABLE
          </button>
        </div>
      </section>

      {/* 6. PRODUCT DETAILS */}
      <section className="py-12 px-4 bg-white" data-id="element-64">
        <div className="max-w-5xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-66">
            📘 ¿Qué incluye exactamente el MEGAPACK?
          </h2>

          <div className="mb-12" data-id="element-67">
            <h3 className="text-2xl font-bold text-yellow-600 mb-6 flex items-center justify-center" data-id="element-68">
              <span className="bg-yellow-100 text-yellow-700 p-2 rounded-lg mr-3" data-id="element-69">
                ✅
              </span>
              6 TOMOS TÉCNICOS PROFESIONALES
            </h3>
            <p className="text-center text-gray-600 mb-8 max-w-3xl mx-auto text-lg" data-id="element-70">
              Organizados para que pienses y trabajes como técnico rentable, no
              como "arreglador de ocasión".
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-71">
              {[{
              title: 'Tomo 1 – Fundamentos del Técnico Rentable',
              desc: 'Cómo funcionan realmente las herramientas eléctricas. Mentalidad profesional, sistemas eléctricos y mecánicos.'
            }, {
              title: 'Tomo 2 – Diagnóstico Profesional',
              desc: 'Cómo encontrar la falla real sin perder tiempo ni plata. Errores comunes que hacen perder guita.'
            }, {
              title: 'Tomo 3 – Reparación de Herramientas Más Comunes',
              desc: 'Taladros, amoladoras, lijadoras, pistolas de calor.'
            }, {
              title: 'Tomo 4 – Herramientas de Corte y Alto Riesgo',
              desc: 'Sierras circulares, tronzadoras, seguridad y mantenimiento rentable.'
            }, {
              title: 'Tomo 5 – Herramientas Especiales',
              desc: 'Rotomartillos, tupíes, batidoras, impacto y transmisión.'
            }, {
              title: 'Tomo 6 – Taller y Sistema Profesional',
              desc: 'Flujo de trabajo, preventivo rentable, entregas sin reclamos y cómo escalar el servicio.'
            }].map((tomo, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-200 hover:border-yellow-400 transition-colors shadow-sm" data-id="element-72">
                  <h4 className="font-bold text-lg text-gray-900 mb-2 flex items-start" data-id="element-73">
                    <span className="text-yellow-600 mr-2" data-id="element-74">📘</span>{' '}
                    {tomo.title}
                  </h4>
                  <p className="text-gray-600 text-sm ml-6" data-id="element-75">{tomo.desc}</p>
                </div>)}
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-76">
            <p className="text-xl font-bold text-gray-800 mb-6" data-id="element-77">
              👉 Abrís el tomo, aplicás y laburás con método.
            </p>
          </div>

          <div className="mt-10 text-center" data-id="element-78">
            <button onClick={scrollToCheckout} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 transition-colors border-b-4 border-green-800" data-id="element-79">
              <span className="text-center" data-id="element-80">👉 ACCEDER CON DESCUENTO</span>
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-81" />
            </button>
          </div>
        </div>
      </section>

      {/* 7. BEFORE / AFTER */}
      <section className="py-12 px-4 bg-gray-100" data-id="element-82">
        <div className="max-w-4xl mx-auto" data-id="element-83">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-84">
            🔄 Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8" data-id="element-85">
            {/* Before */}
            <div className="bg-white p-8 rounded-t-xl md:rounded-xl shadow-sm border-t-8 border-red-500 mb-2 md:mb-0" data-id="element-86">
              <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center" data-id="element-87">
                <XIcon className="w-6 h-6 mr-2" data-id="element-88" />
                Antes del MEGAPACK
              </h3>
              <ul className="space-y-3" data-id="element-89">
                {['Diagnósticos errados', 'Reparaciones lentas', 'Dudas al cobrar', 'Laburo mal pago', 'Desorden y estrés'].map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-90">
                    <span className="text-red-400 mr-3 font-bold" data-id="element-91">•</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-white p-8 rounded-b-xl md:rounded-xl shadow-xl border-t-8 border-green-500 transform md:scale-105 z-10" data-id="element-92">
              <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center" data-id="element-93">
                <Check className="w-6 h-6 mr-2" data-id="element-94" />
                Después del MEGAPACK
              </h3>
              <ul className="space-y-3" data-id="element-95">
                {['Diagnóstico claro', 'Reparaciones seguras', 'Precios definidos', 'Ingresos reales', 'Trabajo profesional'].map((item, i) => <li key={i} className="flex items-start font-bold text-gray-800" data-id="element-96">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-97" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. BONUSES - Black Background for Contrast */}
      <section className="py-14 px-4 bg-gray-900 text-white" data-id="element-98">
        <div className="max-w-6xl mx-auto" data-id="element-99">
          <div className="text-center mb-12" data-id="element-100">
            <span className="bg-yellow-500 text-black font-bold px-4 py-1 rounded-full uppercase tracking-wider text-sm" data-id="element-101">
              🎁 Regalos especiales
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-3 text-white" data-id="element-102">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-xl text-gray-400" data-id="element-103">(Sin costo adicional)</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-104">
            {/* Bonus 1 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-105">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-106">
                <img src={BONUS_1_IMAGE} alt="Bono 1 Precios" className="w-full h-full object-cover" data-id="element-107" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-108">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-109">
                <p className="text-sm text-gray-500 line-through mb-1" data-id="element-110">
                  Valor: ARS $19.990
                </p>
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-111">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-112">
                  🎁 Bono 1 – Cómo Fijar Precios Como Técnico Profesional
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-113">
                  Cuánto cobrar sin miedo. Cómo dejar de regalar tu laburo.
                  Paquetes de servicio que aumentan tus ingresos.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-114">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-115">
                <img src={BONUS_2_IMAGE} alt="Bono 2 Contrato" className="w-full h-full object-cover" data-id="element-116" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-117">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-118">
                <p className="text-sm text-gray-500 line-through mb-1" data-id="element-119">
                  Valor: ARS $15.990
                </p>
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-120">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-121">
                  🎁 Bono 2 – Contrato Legal + Orden de Trabajo (Taller PRO)
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-122">
                  Todo por escrito. Menos reclamos. Autorizaciones, garantías y
                  entregas prolijas.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-123">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-124">
                <img src={BONUS_3_IMAGE} alt="Bono 3 Negocio" className="w-full h-full object-cover" data-id="element-125" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-126">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-127">
                <p className="text-sm text-gray-500 line-through mb-1" data-id="element-128">
                  Valor: ARS $12.990
                </p>
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-129">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-130">
                  🎁 Bono 3 – El Negocio de la Reparación de Herramientas
                  Eléctricas
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-131">
                  Cómo generar ingresos extra. Cómo conseguir clientes sin
                  publicidad. Cómo pasar de "arreglos sueltos" a algo rentable.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. TESTIMONIALS */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-132">
        <div className="max-w-6xl mx-auto" data-id="element-133">
          <h2 className="text-3xl font-bold text-center mb-10 text-gray-900" data-id="element-134">
            Lo que dicen otros profesionales
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-135">
            <TestimonialCard name="Carlos Méndez" role="Técnico Independiente" location="Córdoba" content="Antes perdía horas diagnosticando a ojo. Con el método del MegaPack, ahora encuentro la falla en minutos. Mis clientes notan la diferencia y me recomiendan." imageInitials="CM" data-id="element-136" />
            <TestimonialCard name="Martín Aguirre" role="Reparador de Herramientas" location="Buenos Aires" content="Lo que más me sirvió fue el sistema de precios. Dejé de regalar mi laburo y ahora cobro lo que corresponde. El bono de precios vale oro." imageInitials="MA" data-id="element-137" />
            <TestimonialCard name="Diego Fernández" role="Emprendedor Técnico" location="Rosario" content="Arranqué reparando en el garage de casa. Con los tomos y los protocolos del MegaPack, hoy tengo un taller organizado y clientes fijos. Totalmente recomendado." imageInitials="DF" data-id="element-138" />
            <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6 md:w-2/3 mx-auto" data-id="element-139">
              <TestimonialCard name="Roberto Sánchez" role="Técnico de Taller" location="Mendoza" content="Los tomos de diagnóstico me cambiaron la forma de trabajar. Ya no pruebo piezas al azar. Ahorro tiempo, ahorro plata y el cliente queda conforme." imageInitials="RS" data-id="element-140" />
              <TestimonialCard name="Lucas Pereyra" role="Reparador Independiente" location="La Plata" content="El tomo 6 sobre cómo armar el taller profesional fue clave. Pasé de hacer arreglos sueltos a tener un servicio serio. La guía de precios me dio la confianza que me faltaba." imageInitials="LP" data-id="element-141" />
            </div>
          </div>
        </div>
      </section>

      {/* 10. PRICING / OFFER */}
      <section id="compra" className="py-14 px-4 bg-white" data-id="element-142">
        <div className="max-w-4xl mx-auto" data-id="element-143">
          <div className="border-4 border-dashed border-red-500 rounded-3xl p-6 md:p-10 bg-yellow-50 relative overflow-visible shadow-2xl" data-id="element-144">
            {/* Fixed ribbon */}
            <div className="absolute -top-5 -right-5 bg-red-600 text-white px-6 py-2 font-bold rounded shadow-lg text-sm md:text-base z-10 transform rotate-3" data-id="element-145">
              🔥 OFERTA LIMITADA
            </div>

            <div className="text-center mb-8 pt-4" data-id="element-146">
              <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-147">
                ⏰ Accedé hoy al MEGAPACK TÉCNICO RENTABLE + 3 BONOS GRATIS
              </h2>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-inner mb-8 border border-gray-200" data-id="element-148">
              <h3 className="font-bold text-xl mb-6 border-b pb-4 text-gray-800" data-id="element-149">
                📦 Lo que recibís hoy:
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-150">
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-151">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-152" />
                  <span data-id="element-153">6 Tomos Técnicos</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-154">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-155" />
                  <span data-id="element-156">3 Bonos Profesionales</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-157">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-158" />
                  <span data-id="element-159">Acceso inmediato</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-160">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-161" />
                  <span data-id="element-162">Descarga digital</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-163">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-164" />
                  <span data-id="element-165">Acceso de por vida</span>
                </li>
              </ul>
            </div>

            <div className="text-center" data-id="element-166">
              <div className="flex flex-col items-center justify-center mb-6" data-id="element-167">
                <span className="text-gray-500 text-xl line-through mb-2" data-id="element-168">
                  Precio regular: ARS $49.990
                </span>
                <div className="flex flex-col md:flex-row items-center justify-center gap-3" data-id="element-169">
                  <span className="text-red-600 font-bold text-2xl animate-pulse whitespace-nowrap" data-id="element-170">
                    🔥 HOY SOLO:
                  </span>
                  <span className="text-5xl md:text-6xl font-extrabold text-green-600 whitespace-nowrap" data-id="element-171">
                    ARS $19.990
                  </span>
                </div>
                <p className="text-gray-600 font-medium mt-2" data-id="element-172">
                  Un solo pago. Sin cuotas.
                </p>
              </div>

              <a href={CHECKOUT_URL} className="block w-full py-6 text-2xl md:text-3xl font-extrabold text-white bg-green-600 rounded-xl shadow-xl hover:bg-green-700 transform hover:-translate-y-1 transition-all duration-200 border-b-8 border-green-800 text-center" data-id="element-173">
                👉 OBTENER MI MEGAPACK AHORA
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 11. GUARANTEE */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-174">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8" data-id="element-175">
          <div className="flex-shrink-0 relative" data-id="element-176">
            {/* Shield badge */}
            <div className="w-32 h-36 relative" data-id="element-177">
              <svg viewBox="0 0 100 120" className="w-full h-full" data-id="element-178">
                <path d="M50 5 L95 20 L95 60 C95 85 75 105 50 115 C25 105 5 85 5 60 L5 20 Z" fill="#facc15" stroke="#ca8a04" strokeWidth="3" data-id="element-179" />
                <path d="M50 15 L85 27 L85 58 C85 78 68 95 50 103 C32 95 15 78 15 58 L15 27 Z" fill="#fef08a" data-id="element-180" />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-181">
                <span className="text-3xl" data-id="element-182">🛡️</span>
                <span className="font-extrabold text-yellow-900 text-sm leading-tight text-center mt-1" data-id="element-183">
                  GARANTÍA
                </span>
                <span className="font-bold text-yellow-800 text-xs leading-tight text-center" data-id="element-184">
                  7 DÍAS
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-185">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-186">
              🛡️ GARANTÍA 7 DÍAS
            </h3>
            <p className="text-gray-700 leading-relaxed text-lg" data-id="element-187">
              Probalo tranquilo. Si no te aporta método, claridad y
              rentabilidad, te devolvemos el 100% del dinero. Sin vueltas.
            </p>
          </div>
        </div>
      </section>

      {/* 12. FAQ */}
      <section className="py-12 px-4 bg-white" data-id="element-188">
        <div className="max-w-3xl mx-auto" data-id="element-189">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-190">
            ❓ Preguntas frecuentes
          </h2>
          <FAQ data-id="element-191" />
        </div>
      </section>

      {/* 13. FINAL CTA */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center" data-id="element-192">
        <div className="max-w-3xl mx-auto" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-194">
            La reparación de herramientas eléctricas no se improvisa.
          </h2>
          <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-195">
            La reparación rentable se labura con método.
          </p>
          <button onClick={scrollToCheckout} className="inline-block px-10 py-5 text-xl md:text-2xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-196">
            <span className="text-center" data-id="element-197">
              👉 Accedé ahora al MEGAPACK TÉCNICO RENTABLE
            </span>
          </button>
          <p className="mt-6 text-gray-400" data-id="element-198">
            Y convertí cada herramienta fallada en una oportunidad real de
            ingreso.
          </p>
        </div>
      </section>

      <footer className="py-8 bg-black text-gray-600 text-center text-sm" data-id="element-199">
        <p data-id="element-200">© 2026 MegaPack Técnico Rentable. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-201">
          Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}
function XIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-202">
      <path d="M18 6 6 18" data-id="element-203" />
      <path d="m6 6 12 12" data-id="element-204" />
    </svg>;
}